import { createContext } from 'react';
import utils from '../../utils';
import { DataRoomNode } from 'router/subrouters/DataRoom/models/DataRoomNode';
import { QAndASides } from 'router/subrouters/DataRoom/models/QAndA';

export type MixpanelProps = {
  dataRoomName: string;
  ownerId: string;
  userSide: QAndASides;
};

type DocumentViewContextValues = {
  openNode: (node: DataRoomNode, mixpanelProps?: MixpanelProps) => void;
};

export default createContext<DocumentViewContextValues>({
  openNode: utils.noop,
});
